<div class="fondo-cursos">
  <div class="lazy-wrapper" *ngFor="let page of pages; let i = index" #lazyWrapper>
    <ng-container #dynamicContainer></ng-container>
  </div>
</div>